<template>
    <div class="mb-6 flex gap-2">
        <ul class="m-0 grid w-[280px] list-none grid-cols-1 gap-2 bg-ds-primary-800 p-2">
            <DsSideNavItem
                icon="fa-regular fa-folder"
                label="Files"
                url="/user/home"
            />
            <DsSideNavItem
                icon="fa-regular fa-shield-check"
                label="Payoff verifications"
                url="/user/payoffs"
            />
            <DsSideNavItem
                icon="fa-regular fa-message-lines"
                label="Conversations"
                url="/user/conversation"
            />
            <DsSideNavItem
                icon="fa-regular fa-files"
                label="Documents"
                url="/design/side-nav"
            />
            <DsSideNavItem
                firstName="John"
                label="John Seller"
                url="/user/home"
            />
        </ul>

        <ul class="m-0 grid w-[280px] list-none grid-cols-1 gap-2 bg-ds-primary-800 p-2">
            <DsSideNavItem
                icon="fa-regular fa-folder"
                label="Files"
                url="/user/home"
            >
                <DsBadge
                    text="New"
                    variant="active"
                />
            </DsSideNavItem>
            <DsSideNavItem
                icon="fa-regular fa-shield-check"
                label="Payoff verifications"
                url="/user/payoffs"
            >
                <DsBadge
                    text="New"
                    variant="active"
                />
            </DsSideNavItem>
            <DsSideNavItem
                icon="fa-regular fa-message-lines"
                label="Conversations"
                url="/user/conversation"
            >
                <DsBadge
                    text="New"
                    variant="active"
                />
            </DsSideNavItem>
            <DsSideNavItem
                icon="fa-regular fa-files"
                label="Documents"
                url="/design/side-nav"
            >
                <DsBadge
                    text="New"
                    variant="active"
                />
            </DsSideNavItem>
            <DsSideNavItem
                firstName="John"
                label="John Seller"
                url="/user/home"
            >
                <DsBadge
                    text="New"
                    variant="active"
                />
            </DsSideNavItem>
        </ul>

        <ul class="m-0 grid w-[280px] list-none grid-cols-1 gap-2 bg-ds-primary-800 p-2">
            <DsSideNavItem
                icon="fa-regular fa-folder"
                label="Files"
                url="/user/home"
            >
                <DsIcon
                    icon="fa-regular fa-chevron-right"
                    size="sm"
                />
            </DsSideNavItem>
            <DsSideNavItem
                icon="fa-regular fa-shield-check"
                label="Payoff verifications"
                url="/user/payoffs"
            >
                <DsIcon
                    icon="fa-regular fa-chevron-right"
                    size="sm"
                />
            </DsSideNavItem>
            <DsSideNavItem
                icon="fa-regular fa-message-lines"
                label="Conversations"
                url="/user/conversation"
            >
                <DsIcon
                    icon="fa-regular fa-chevron-right"
                    size="sm"
                />
            </DsSideNavItem>
            <DsSideNavItem
                icon="fa-regular fa-files"
                label="Documents"
                url="/design/side-nav"
            >
                <DsIcon
                    icon="fa-regular fa-chevron-right"
                    size="sm"
                />
            </DsSideNavItem>
            <DsSideNavItem
                firstName="John"
                label="John Seller"
                url="/user/home"
            >
                <DsIcon
                    icon="fa-regular fa-chevron-right"
                    size="sm"
                />
            </DsSideNavItem>
        </ul>

        <ul class="m-0 grid w-[280px] list-none grid-cols-1 gap-2 bg-ds-primary-800 p-2">
            <DsSideNavItem
                icon="fa-regular fa-folder"
                label="Files"
                url="/user/home"
            >
                <span
                    class="flex size-5 items-center justify-center rounded-full bg-ds-red-600 p-1 text-[10px] text-content-inverse"
                >
                    10
                </span>
            </DsSideNavItem>
            <DsSideNavItem
                icon="fa-regular fa-shield-check"
                label="Payoff verifications"
                url="/user/payoffs"
            >
                <span
                    class="flex size-5 items-center justify-center rounded-full bg-ds-red-600 p-1 text-[10px] text-content-inverse"
                >
                    10
                </span>
            </DsSideNavItem>
            <DsSideNavItem
                icon="fa-regular fa-message-lines"
                label="Conversations"
                url="/user/conversation"
            >
                <span
                    class="flex size-5 items-center justify-center rounded-full bg-ds-red-600 p-1 text-[10px] text-content-inverse"
                >
                    10
                </span>
            </DsSideNavItem>
            <DsSideNavItem
                icon="fa-regular fa-files"
                label="Documents"
                url="/design/side-nav"
            >
                <span
                    class="flex size-5 items-center justify-center rounded-full bg-ds-red-600 p-1 text-[10px] text-content-inverse"
                >
                    10
                </span>
            </DsSideNavItem>
            <DsSideNavItem
                firstName="John"
                label="John Seller"
                url="/user/home"
            >
                <span
                    class="flex size-5 items-center justify-center rounded-full bg-ds-red-600 p-1 text-[10px] text-content-inverse"
                >
                    10
                </span>
            </DsSideNavItem>
        </ul>
    </div>

    <nav
        class="side-nav-sample flex min-h-[480px] flex-col gap-2 overflow-hidden bg-ds-primary-800 p-2 transition-[width] duration-200 ease-in-out"
        :class="expanded ? 'side-nav-sample--expanded w-[280px]' : 'w-16'"
    >
        <ul
            v-if="expanded"
            class="m-0 flex list-none items-center justify-between p-0"
        >
            <DsSideNavItem
                class="w-fit"
                icon="fak fa-cl-logo"
                label="Closinglock"
                url="/user/home"
            />
            <DsSideNavItem @click="expanded = false">
                <DsIcon
                    icon="fak fa-sidenav-close"
                    size="md"
                />
            </DsSideNavItem>
        </ul>
        <ul
            v-else
            class="m-0 list-none p-0"
        >
            <DsSideNavItem
                class="group relative"
                :expanded="false"
                :tooltipText="'Open sidebar'"
                @click="expanded = true"
            >
                <DsIcon
                    class="transition-opacity group-hover:opacity-0"
                    icon="fak fa-cl-logo"
                    size="md"
                />
                <DsIcon
                    class="absolute opacity-0 transition-opacity group-hover:opacity-100"
                    icon="fak fa-sidenav-open"
                    size="md"
                />
            </DsSideNavItem>
        </ul>

        <hr class="side-nav-sample__divider" />

        <ul class="side-nav-sample__nav-links m-0 flex list-none flex-col gap-2 p-0">
            <DsSideNavItem
                :expanded
                icon="fa-regular fa-folder"
                label="Files"
                :tooltipText="!expanded ? 'Files' : ''"
                url="/user/home"
            />
            <DsSideNavItem
                :expanded
                icon="fa-regular fa-shield-check"
                label="Payoff verifications"
                :tooltipText="!expanded ? 'Payoff verifications' : ''"
                url="/user/payoffs"
            >
                <DsBadge
                    text="New"
                    variant="active"
                />
            </DsSideNavItem>
            <DsSideNavItem
                class="side-nav-sample__conversations"
                :expanded
                icon="fa-regular fa-message-lines"
                label="Conversations"
                :tooltipText="!expanded ? 'Conversations' : ''"
                url="/user/conversation"
            >
                <span
                    v-if="expanded"
                    class="flex size-5 items-center justify-center rounded-full bg-ds-red-600 p-1 text-[10px] text-content-inverse"
                >
                    10
                </span>
            </DsSideNavItem>
        </ul>

        <hr class="side-nav-sample__divider" />

        <ul class="m-0 list-none p-0">
            <DsSideNavItem
                :expanded="expanded"
                icon="fa-regular fa-files"
                label="Documents"
                :tooltipText="!expanded ? 'Documents' : ''"
                url="/user/document-management"
            />
        </ul>

        <ul class="m-0 mt-auto flex list-none flex-col gap-2 p-0">
            <DsSideNavItem
                :expanded="expanded"
                icon="fa-regular fa-gear"
                label="Settings"
                :tooltipText="!expanded ? 'Settings' : ''"
                url="/user/settings"
            />
            <DsSideNavItem
                :expanded="expanded"
                firstName="Sally"
                label="Sally Agent"
                :tooltipText="!expanded ? 'Account details' : ''"
                url="/user/home"
            >
                <DsIcon
                    v-show="expanded"
                    icon="fa-regular fa-chevron-right"
                    size="sm"
                />
            </DsSideNavItem>
        </ul>
    </nav>
</template>

<script setup lang="ts">
import DsBadge from '@/components/design-system/badge/BadgeCore.vue';
import DsIcon from '@/components/design-system/DsIcon.vue';
import DsSideNavItem from '@/components/Navigation/side-nav/DsSideNavItem.vue';
import { ref } from 'vue';

const expanded = ref(true);
</script>

<style scoped>
.side-nav-sample:not(.side-nav-sample--expanded) :deep(.ds-nav-item) {
    @apply w-full justify-center px-3;
}

.side-nav-sample:not(.side-nav-sample--expanded) :deep(.ds-nav-item > div:first-child) {
    @apply flex flex-1 justify-center gap-0;
}

.side-nav-sample:not(.side-nav-sample--expanded) :deep(.ds-nav-item > div:first-child + div:last-child) {
    @apply !hidden;
}

.side-nav-sample :deep(.ds-nav-item > div:first-child > span) {
    @apply overflow-hidden whitespace-nowrap transition-[opacity,width] duration-200 ease-in-out;
}

.side-nav-sample:not(.side-nav-sample--expanded) :deep(.ds-nav-item > div:first-child > span) {
    @apply hidden;
}

.side-nav-sample :deep(.ds-nav-item > div:last-child) {
    @apply overflow-hidden transition-[opacity,width] duration-200 ease-in-out;
}

.side-nav-sample--expanded :deep(.ds-nav-item > div:last-child) {
    @apply flex flex-1;
}

.side-nav-sample__divider {
    @apply border-t border-white/10;
}

.side-nav-sample:not(.side-nav-sample--expanded) :deep(.side-nav-sample__conversations .ds-nav-item) {
    @apply relative;
}

.side-nav-sample:not(.side-nav-sample--expanded) :deep(.side-nav-sample__conversations .ds-nav-item)::after {
    content: '';
    @apply pointer-events-none absolute right-3 top-3 size-2 rounded-full bg-ds-red-600;
}
</style>
